import { render, staticRenderFns } from "./MaterialDetails.vue?vue&type=template&id=61f35993&"
import script from "./MaterialDetails.vue?vue&type=script&lang=js&"
export * from "./MaterialDetails.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports